var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"icon-button",attrs:{"type":"button","aria-label":_vm.label,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }